import { Box, ButtonBase, Typography } from "@mui/material";

const PlanCard = ({
  planName,
  planDescription,
  planPrice,
  onClick,
  selected,
  noPointer,
}) => {
  return (
    <ButtonBase
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "#1F222A",
        borderRadius: "10px",
        padding: "10px 20px",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: !selected && !noPointer ? "pointer" : "default",
        gap: "10px",
        transition: "border 0.3s, box-shadow 0.3s",
        border: selected
          ? "2px solid #FF6401"
          : "2px solid rgba(255, 255, 255, 0)",
      }}
      onClick={onClick}
    >
      <Box>
        <Typography
          style={{
            fontSize: "24px",
            fontFamily: "Urbanist",
            fontWeight: "bold",
            color: "rgba(255, 255, 255, 1)",
            textAlign: "left",
          }}
        >
          {planName}
        </Typography>
        <Typography
          style={{
            fontSize: "15px",
            fontFamily: "Urbanist",
            fontWeight: "500",
            color: "rgba(255, 255, 255, 1)",
            maxWidth: "300px",
            textAlign: "left",
          }}
        >
          {planDescription}
        </Typography>
      </Box>
      <Typography
        style={{
          fontSize: "20px",
          fontFamily: "Urbanist",
          fontWeight: "bold",
          color: "rgba(255, 255, 255, 1)",
          textAlign: "center",
        }}
      >
        {planPrice}
      </Typography>
    </ButtonBase>
  );
};

export default PlanCard;
